import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { EXPERIENCIAS, wa } from "../lib/site";

export default function Experiencias() {
  const [first, ...rest] = EXPERIENCIAS;

  return (
    <section id="passeios" className="py-24 md:py-32 bg-sand" data-testid="experiencias-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-2xl">
          <Reveal>
            <SectionTag>Passeios e experiências</SectionTag>
            <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-brand-deep text-balance">
              O que vamos <span className="font-serif italic font-medium text-brand-light">viver juntos?</span>
            </h2>
          </Reveal>
        </div>

        <Reveal>
          <a
            href={wa(`Olá, Magnus! ${first.cta}.`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`experiencia-card-${first.slug}`}
            className="group relative block overflow-hidden rounded-3xl min-h-[380px] md:min-h-[440px]"
          >
            <img src={first.img} alt={first.tag} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-deep/90 via-brand-deep/40 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 md:p-12 max-w-xl">
              <span className="text-accent-soft text-xs font-bold uppercase tracking-[0.3em]">{first.flag} {first.tag}</span>
              <h3 className="mt-3 font-display font-extrabold text-white text-2xl sm:text-3xl lg:text-4xl">{first.title}</h3>
              <p className="mt-3 text-white/80 text-sm md:text-base leading-relaxed">{first.desc}</p>
              <span className="mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-brand-deep transition-transform duration-300 group-hover:scale-[1.04]">
                {first.cta}
                <ArrowRight size={15} />
              </span>
            </div>
          </a>
        </Reveal>

        <div className="mt-5 grid sm:grid-cols-2 gap-5">
          {rest.map((e, i) => (
            <Reveal key={e.slug} delay={(i % 2) * 0.1}>
              <a
                href={wa(`Olá, Magnus! ${e.cta}.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`experiencia-card-${e.slug}`}
                className="group relative block overflow-hidden rounded-3xl aspect-[16/10]"
              >
                <img src={e.img} alt={e.tag} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/90 via-brand-deep/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <span className="text-accent-soft text-[11px] font-bold uppercase tracking-[0.3em]">{e.flag} {e.tag}</span>
                  <h3 className="mt-2 font-display font-bold text-white text-xl">{e.title}</h3>
                  <p className="mt-2 text-white/75 text-sm leading-relaxed line-clamp-2">{e.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.2em] text-white">
                    {e.cta}
                    <ArrowRight size={14} className="text-accent transition-transform duration-300 group-hover:translate-x-1.5" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
          <a
            href="/passeios"
            data-testid="experiencias-ver-detalhes"
            className="group mt-10 inline-flex items-center gap-2 rounded-full border border-brand/20 px-8 py-4 text-sm font-bold text-brand transition-colors duration-300 hover:bg-brand hover:text-white"
          >
            Ver detalhes dos passeios
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
